import { render } from "./CRMHigh.vue?vue&type=template&id=06c28023&scoped=true"
import script from "./CRMHigh.vue?vue&type=script&lang=js"
export * from "./CRMHigh.vue?vue&type=script&lang=js"

import "./CRMHigh.vue?vue&type=style&index=0&id=06c28023&scoped=true&lang=css"
import "./CRMHigh.vue?vue&type=style&index=1&id=06c28023&lang=css"
script.render = render
script.__scopeId = "data-v-06c28023"

export default script